import React from 'react';
import PropTypes from "prop-types";
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLogout } from '../context/LogoutContext';

const Header = ({title, toggleSidebar}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { openLogoutDialog } = useLogout();

    // const handleLogout = () => {
    //     try {
    //         // dispatch(logOutUser());
    //         localStorage.removeItem("accessToken");
    //         toast.success("Admin Logout Successfully...!");
    //         navigate("../");
    //     } catch (error) {
    //         console.log("error", error);
    //     }
    // }
    return (
        <div className="p-3 md:p-5 bg-gray_1 sticky top-0 z-40">
            <div className="flex flex-wrap items-center">
                {/* Hamburger Menu for Mobile */}
                <button 
                    className="xl:hidden flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded-lg"
                    onClick={toggleSidebar}
                    aria-label="Menu"
                >
                    <svg 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </button>

                <span className="inline-block text-22 lg:text-26 font-bold pl-3 lg:pl-8">
                    {title}
                </span>

                <div className="flex flex-wrap items-center sm:ml-auto space-x-4 lg:space-x-6 space-y-2 lg:space-y-0 pt-2 md:pt-0">
                    {/* Search Bar */}
                    {/* <div className="w-full md:w-[320px] lg:w-[400px] bg-white rounded-lg ml-auto custom_shadow">
                        <div>
                            <label htmlFor="search" className="input search_inpu">
                            <span className="icon-search">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_1_405)">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.33398 0.167969C3.74413 0.167969 0.833984 3.07812 0.833984 6.66797C0.833984 10.2578 3.74413 13.168 7.33398 13.168C10.9238 13.168 13.834 10.2578 13.834 6.66797C13.834 3.07812 10.9238 0.167969 7.33398 0.167969ZM1.83398 6.66797C1.83398 3.6304 4.29642 1.16797 7.33398 1.16797C10.3716 1.16797 12.834 3.6304 12.834 6.66797C12.834 9.70553 10.3716 12.168 7.33398 12.168C4.29642 12.168 1.83398 9.70553 1.83398 6.66797Z" fill="#AFBACA"/>
                                    <path d="M13.0209 11.6478C12.8257 11.4525 12.5091 11.4525 12.3138 11.6478C12.1185 11.8431 12.1185 12.1597 12.3138 12.3549L14.9804 15.0215C15.1757 15.2168 15.4922 15.2168 15.6875 15.0216C15.8828 14.8263 15.8828 14.5097 15.6875 14.3144L13.0209 11.6478Z" fill="#AFBACA"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_1_405">
                                    <rect width="16" height="16" fill="white"/>
                                    </clipPath>
                                    </defs>
                                    </svg>
                              </span>
                                <input
                                    type="search"
                                    placeholder="Search By Customer ID, Name..."
                                    id="search"
                                    className="w-full"
                                />
                            </label>
                        </div>
                    </div> */}

                    {/* Notification Icon */}
                    {/* <div className="rounded-full bg-white flex items-center justify-center w-9 h-9 lg:w-10 lg:h-10 2xl:w-12 2xl:h-12">
                    <span className="flex-shrink-0">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.38457 12.5135H8.63036C7.4337 10.9637 7.43381 8.48709 8.63039 6.93733H7.52563C9.64443 3.08088 15.2969 3.08352 17.4146 6.93733H16.3097C17.5064 8.48719 17.5063 10.9638 16.3097 12.5135H17.5555C18.4697 12.5135 19.2135 11.7697 19.2135 10.8555V8.59534C19.2135 8.21222 19.0825 7.85934 18.8635 7.57824C16.7491 1.47918 8.19867 1.46862 6.07649 7.57835C5.85752 7.85941 5.72656 8.21226 5.72656 8.59531V10.8555C5.72656 11.7697 6.47035 12.5135 7.38457 12.5135Z" fill="#AFBACA"/>
                                <path d="M19.9065 19.4051C19.2642 16.453 16.5678 13.4184 12.4712 13.418C8.5413 13.418 5.71831 16.2785 5.02957 19.3965C4.85353 20.224 5.48603 21.0026 6.32987 21.0023C8.98625 21.0023 16.0427 21.0023 18.6126 20.9941C19.4501 20.9941 20.076 20.2253 19.9065 19.4051Z" fill="#AFBACA"/>
                                <path d="M13.6008 10.8943H15.9728C16.7902 8.572 14.9434 5.99079 12.4707 6.03573C10.4352 6.0357 8.7793 7.69163 8.7793 9.72706C8.78693 13.2667 13.3191 14.7437 15.4156 11.9501H13.6008C12.9014 11.9243 12.9014 10.9201 13.6008 10.8943Z" fill="#AFBACA"/>
                                </svg>
                                
                        </span>
                    </div> */}

                    {/* Logout Icon */}
                    <div className="rounded-full bg-white flex items-center justify-center w-9 h-9 lg:w-10 lg:h-10 2xl:w-12 2xl:h-12 cursor-pointer" onClick={openLogoutDialog}>
                    <span className="flex-shrink-0">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M7 11.25C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75L15 12.75L15 15C15 15.929 15 16.3935 14.9384 16.7822C14.5996 18.9216 12.9216 20.5996 10.7822 20.9384C10.3935 21 9.929 21 9 21C8.07099 21 7.60649 21 7.21783 20.9384C5.07836 20.5996 3.40041 18.9216 3.06156 16.7822C3 16.3935 3 15.929 3 15L3 9C3 8.07099 3 7.60649 3.06156 7.21783C3.40042 5.07836 5.07837 3.40042 7.21783 3.06156C7.60649 3 8.07099 3 9 3C9.92901 3 10.3935 3 10.7822 3.06156C12.9216 3.40042 14.5996 5.07836 14.9384 7.21783C15 7.60649 15 8.07099 15 9L15 11.25L7 11.25ZM15 11.25L19.8105 11.25C19.483 10.9273 19.001 10.5437 18.297 9.98553L16.534 8.58768C16.2095 8.33034 16.155 7.8586 16.4123 7.53403C16.6697 7.20946 17.1414 7.15497 17.466 7.41232L19.2648 8.83857C19.9372 9.37175 20.4922 9.81172 20.8875 10.2055C21.2932 10.6096 21.6294 11.0582 21.7208 11.6313C21.7402 11.7534 21.75 11.8766 21.75 12C21.75 12.1234 21.7402 12.2466 21.7208 12.3687C21.6294 12.9418 21.2932 13.3904 20.8875 13.7945C20.4922 14.1883 19.9373 14.6282 19.2648 15.1614L17.466 16.5877C17.1414 16.845 16.6697 16.7905 16.4123 16.466C16.155 16.1414 16.2095 15.6697 16.534 15.4123L18.297 14.0145C19.001 13.4563 19.483 13.0727 19.8105 12.75L15 12.75L15 11.25Z" fill="#AFBACA"/>
                                </svg>
                                
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

Header.propTypes = {
    title: PropTypes.string,
    toggleSidebar: PropTypes.func.isRequired,
};

export default Header;
